<template>
  <label
    class="flex items-start gap-spacing_3"
    :class="{ 'flex-row-reverse': rightAligned }"
  >
    <button
      type="button"
      class="flex aspect-square h-icon_size_6 w-icon_size_6 items-center justify-center rounded-r3 border-[0.5px] border-neutral-800 bg-neutral-50 transition"
      :disabled
      :class="{
        '!border-action !bg-action': modelValue,
        'cursor-pointer': !disabled,
        'cursor-not-allowed !border-neutral-600 !bg-neutral-600':
          modelValue && disabled,
        'cursor-not-allowed !border-neutral-500 !bg-neutral-400':
          !modelValue && disabled,
      }"
      @click.prevent="handleChange"
    >
      <CommonUIcons
        v-if="modelValue"
        name="ic-check"
        class="h-icon_size_3 w-icon_size_3 text-action_text"
      />
    </button>

    <span
      class="w-full font-secondary text-size_4"
      :class="disabled ? 'text-neutral-600' : 'text-neutral-800'"
    >
      <span>{{ label }}</span>
      <span v-if="required" class="text-errors">*</span>
    </span>
  </label>
</template>

<script setup lang="ts">
import type { CheckboxProps } from "~/types/schemas/common/Atom/checkbox";

defineProps<CheckboxProps>();
const modelValue = defineModel<boolean>({ default: false });

const handleChange = () => {
  modelValue.value = !modelValue.value;
};
</script>
